
var windowIsTurbolinked = 'Turbo' in window;

function grantGoogleConsent() {
  gtag('consent', 'update', {
    'ad_user_data': 'granted',
    'ad_personalization': 'granted',
    'ad_storage': 'granted',
    'analytics_storage': 'granted'
  });
}

function updateGoogleConsent(json) {
  var performanceWasGranted = window.performanceConsentGranted === true;
  window.performanceConsentGranted = json.analytics_storage === 'granted';
  gtag('consent', 'update', json);

  if (
    json.ad_storage === 'denied' &&
    window.googleTagManagerLoaded
  ) {
    window.location.reload();
    return true;
  }

  if (
    json.analytics_storage === 'granted' ||
    json.ad_storage === 'granted'
  ) {
    window.loadGoogleTagManager && window.loadGoogleTagManager();
  }

  if (
    !performanceWasGranted &&
    window.performanceConsentGranted &&
    typeof window.queueGooglePageView === 'function'
  ) {
    window.queueGooglePageView(window.location.href);
  }

  return false;
}

function consentCsrfHeaders() {
  return { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') };
}

// A rejected consent write (e.g. a stale CSRF token after the session was
// lost) must not look saved: reload so the banner and a fresh token return.
// Status 0 is an aborted request (e.g. navigating away), so leave it alone.
function consentRequestFailed(xhr) {
  if (xhr.status === 0) return;

  console.warn("Cookie consent was not saved (HTTP " + xhr.status + "). Reloading.");
  window.location.reload();
}

$(document).on("turbo:load", function(){ 
  if($('#cookies-eu-modal').length){
      $('#cookies-eu-modal').modal({ backdrop: 'static', keyboard: false })

      $('.js-cookies-eu-performance').on("click", function(event){
        $.ajax({
        url: "/performance_consent", method: "post",
        data: { performance_consent: event.target.checked },
        headers: consentCsrfHeaders(),
        cache: false,
        error: consentRequestFailed
        });
      });

      $('.js-cookies-eu-targeting').on("click", function(event){
        $.ajax({
        url: "/targeting_consent", method: "post",
        data: { targeting_consent: event.target.checked },
        headers: consentCsrfHeaders(),
        cache: false,
        error: consentRequestFailed
        });
      });

      $('.js-cookies-eu-functionality').on("click", function(event){
        $.ajax({
        url: "/functionality_consent", method: "post",
        data: { functionality_consent: event.target.checked },
        headers: consentCsrfHeaders(),
        cache: false,
        error: consentRequestFailed
        });
      });

      $('.js-cookies-eu-acceptall').on("click", function(event){
          $.ajax({
            url: "/accept_all", method: "post",
            headers: consentCsrfHeaders(),
            cache: false,
            dataType: "json",
            success: function(data) {
              console.log("Cookies saved. " + JSON.stringify(data));
              if (updateGoogleConsent(data)) return;

              // clear turbolinks cache so cookie banner does not reappear
              windowIsTurbolinked && window.Turbo.cache.clear();
            },
            error: consentRequestFailed
          });
        });

        $('.js-cookies-eu-save').on("click", function(event){
          $.ajax({
            url: "/save_consent", method: "post",
            headers: consentCsrfHeaders(),
            cache: false,
            dataType: "json",
            success: function(data) {
              console.log("Cookies saved. " + JSON.stringify(data));
              if (updateGoogleConsent(data)) return;

              // clear turbolinks cache so cookie banner does not reappear
              windowIsTurbolinked && window.Turbo.cache.clear();
            },
            error: consentRequestFailed
          });
        });
  };
})
